import { CircularProgress } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import ConfirmationModal from 'src/consumer/components/helperComponents'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import useClinicLocationsByBrand from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/useClinicLocationsByBrand'
import usePrescriptionTemplateFormStates from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/usePrescriptionTemplateFormStates'
import PrescriptionTemplateForm from 'src/mentor/components/MentorPrescriptionTemplates/components/PrescriptionTemplateForm'
import PrescriptionViewPageHeading from 'src/mentor/components/MentorPrescriptionTemplates/components/PrescriptionViewPageHeading'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import {
  AvailabilityPageContainer,
  PageHeadlineComponent,
} from '../../MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function PrescriptionViewPage() {
  const { clinicId } = useParams()
  const [searchParams] = useSearchParams()
  const eventId = searchParams.get('eventId')
  const { mentorClinicAssociationData, mentorProfileData } = useContext(MentorProfileContext)
  const { unSecureSetupData } = useContext(UnsecureSetupContext)

  const { clinicLocationOptions, clinicBrands } = useClinicLocationsByBrand({
    mentorClinicAssociationData,
  })
  const {
    handlers,
    loading,
    printPreviewType,
    setPrintPreviewType,
    paperPrescriptionTemplate,
    setPaperPrescriptionTemplate,
    pdfPrescriptionTemplate,
    setPdfPrescriptionTemplate,
    addTemplate,
    deleteTemplate,
    activateTemplate,
    pdfOptions,
    paperOptions,
    paperPrintSettings,
    handleSubmit,
    savePrescriptionTemplate,
    confirmationModalProps,
  } = usePrescriptionTemplateFormStates({
    clinicId,
    clinicBrands,
    mentorClinicAssociationData,
    mentorProfileData,
  })

  // const {
  //   confirmationModalProps,
  //   handleSubmit,
  //   savePrescriptionTemplate,
  //   activatePrescriptionTemplate,
  //   createPrescriptionTemplate,
  //   handleDelete,
  // } = usePrescriptionTemplateActions({
  //   clinicId,
  //   mentorClinicAssociationData,
  //   mentorProfileData,
  // })
  // Custom hooks for handlers and save logic

  return (
    <>
      <style>
        {`
          @media print {
            /* Hide all scrollbars */
            * {
              scrollbar-width: none !important;
              -ms-overflow-style: none !important;
            }
            *::-webkit-scrollbar {
              display: none !important;
              width: 0 !important;
              height: 0 !important;
            }
            /* Remove all shadows */
            * {
              box-shadow: none !important;
            }
            /* Ensure no overflow issues */
            body {
              overflow: visible !important;
            }
            html {
              overflow: visible !important;
            }
            /* Remove any right-side spacing that might be caused by scrollbars */
            body, html {
              margin-right: 0 !important;
              padding-right: 0 !important;
            }
          }
        `}
      </style>
      <AvailabilityPageContainer>
        <PageHeadlineComponent
          pageContainerCustomStyles={{ marginBottom: '0px' }}
          fullWidthHeader
          heading={
            <PrescriptionViewPageHeading
              clinicId={clinicId}
              clinicLocationOptions={clinicLocationOptions}
              mentorClinicAssociationData={mentorClinicAssociationData}
            />
          }
        />
        {loading && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              maxWidth: '768px',
              height: '100%',
              margin: '30px auto',
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          // Pass down the clinic location here
          <>
            <PrescriptionTemplateForm
              printPreviewType={printPreviewType}
              pdfOptions={pdfOptions}
              printOptions={paperOptions}
              setPrintPreviewType={setPrintPreviewType}
              prescriptionTemplate={
                printPreviewType === 'print' ? paperPrescriptionTemplate : pdfPrescriptionTemplate
              }
              setPrescriptionTemplate={
                printPreviewType === 'print'
                  ? setPaperPrescriptionTemplate
                  : setPdfPrescriptionTemplate
              }
              templateActions={{
                addTemplate,
                deleteTemplate,
                activateTemplate,
              }}
              handlers={handlers}
              customOptions={unSecureSetupData}
              disabled={false}
              isUsingNewPrintMethod={paperPrintSettings?.useNewPrintMethod}
              handleSubmit={handleSubmit}
              eventId={eventId}
              mentorProfileData={mentorProfileData}
              savePrescriptionTemplate={savePrescriptionTemplate}
              clinicId={clinicId}
            />
            <ConfirmationModal {...confirmationModalProps} newImplementation />
          </>
        )}
      </AvailabilityPageContainer>
    </>
  )
}
